module.exports = __webpack_public_path__ + "blue-location.png";